(ns motorsaif.web.pages.ops.show
  (:require
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.shared.ops :as shared-ops]
   [motorsaif.web.components :as c]
   [motorsaif.web.pages.ops.components :as comps-ops]
   [re-frame.core :as rf :refer [subscribe]]))

(defn no-items-state []
  [:div.no-items-state
   [:div.empty-icon
    [:i.fa-regular.fa-folder-open]]
   [:div.empty-message
    [:h3 (tr :nothing-to-show "No items")]
    [:p "Check back later for new items in this category"]]])

(defn show-items [items]
  (let [{:keys [category]} @(subscribe [:route/parameters])
        {:keys [title icon desc]} (first (filter #(= category (% :category)) shared-ops/categories))]
    [:section
     (if (empty? items)
       [no-items-state]
       (into [:div.items]
             (map comps-ops/preview-item items)))]))

(defn root []
  (let [params (subscribe [:route/parameters])
        ;; items @(rf/subscribe [:responder-threads-with-messages])
        {:keys [category]} @(subscribe [:route/parameters])
        {:keys [title icon desc]} (first (filter #(= category (% :category)) shared-ops/categories))
        items @(rf/subscribe [(keyword :ops category)])]
    [:div#ops
     [c/header-with-back
      [:div#header
       [:div.title
        [:span.icon icon]
        [:span.title title]]
       [:div.count
        [:span (count items)]]]
      {:subtitle desc}]
     [:div.content.container-sm
      [show-items items]]]))
